/** @format */

import React, { useEffect, useState } from 'react';
import I18n from '../../components/Translate/I18n';
import { FormGeneralHelper } from '../../helpers/FormGeneral';
import GridContainer from '../../components/Grid/GridContainer';
import Card from '../../components/Card/Card';
import CardHeader from '../../components/Heading/CardHeaderExt';
import CardBody from '../../components/Card/CardBody';
import GridItem from '../../components/Grid/GridItem';
import { useDispatch } from 'react-redux';
import InputForm from '../../components/Form/InputForm';
import CardFooter from '../../components/Card/CardFooter';
import CheckBoxSimple from '../../components/Form/CheckBoxSimple';
import SimpleSelectRest from '../../components/Adescom/SimpleSelectRest';
import { roles, UserRoleHelper } from '../../helpers/UserRoleHelper';
import { platformUserDefinedRolesConstants, platformUserDefinedRolesReducers } from '../../modules/platformGroups/reducers';
import { store } from '../../core/store';
import { ItemLoaders } from '../../core/loaders/ItemLoaders';
import { configDefault } from '../../core/config';
import CustomTextButtom from '../../components/Buttons/CustomTextButton';
import { Button, makeStyles } from '@material-ui/core';
import { apiCall } from '../../core/apiCall';
import adescomStyle from '../../assets/jss/adescom/adescomStyle';
import { NotificationHelper } from '../../helpers/NotificationHelper';
import { DateHelper } from '../../helpers/DateHelper';
import CustomDatePicker from '../../components/Form/CustomDatePicker';
import { Moment } from 'moment';
import { DateHelperTs } from '../../helpers/DateHelperTs';
import { Auth } from '../../modules/auth/Auth';
import PlatformUser from '../../interfaces/platform/PlatformUser';

store.injectReducer('platformUserDefinedRolesReducers', platformUserDefinedRolesReducers);

export type PlatformUserSendType = {
    id?: number | null;
    personName: string;
    username: string;
    newPassword?: string | null;
    repeatPassword?: string | null;
    email: string;
    platformResellerId?: number;
    allowGenericLogin?: boolean;
    platformUserApiRoles?: Array<string>;
    permissionGroupId?: number | null;
    activatedAt: string | null;
    systemAccount: boolean;
    certificateValidTo: string | null | undefined;
    certificateSerialHash: string | null | undefined;
    accountExpiration?: Date | string | null;
};

export type PlatformUserModifyType = {
    userId?: string | null;
    platformUser?: PlatformUser | null;
    resellerId?: string | null;
    outputObject?: PlatformUserSendType;
    savePlatformUser: (outputObject: PlatformUserSendType, errors?: Array<string>) => void;
};

const useStyle = makeStyles(adescomStyle);
export const PlatformUserModify = (props: PlatformUserModifyType): React.ReactElement => {
    const dispatch = useDispatch();
    const savePlatformUser = props.savePlatformUser;
    const [outputObject, setOutputObject] = useState<PlatformUserSendType>({
        personName: '',
        username: '',
        email: '',
        newPassword: null,
        repeatPassword: null,
        allowGenericLogin: true,
        permissionGroupId: null,
        systemAccount: false,
        certificateSerialHash: undefined,
        certificateValidTo: undefined,
        accountExpiration: null,
    } as PlatformUserSendType);
    const [platformUserStatus, setPlatformUserStatus] = useState<any>({});
    const id = window.sessionStorage.getItem('userid');
    const [file, setFile] = useState<File | null>(null);
    const [fileName, setFileName] = useState<string | null>(null);
    const [serial, setSerial] = useState<string | null>(null);
    const [serialExpiration, setSerialExpiration] = useState<string | null>(null);
    const [accountExpirationSetManually, setAccountExpirationSetManually] = useState<boolean>(false);
    const classes = useStyle();
    const [collections, setCollections] = useState<any>(null);
    const [collectionSelect, setCollectionSelect] = useState<any>(null);

    const updateCallback = (
        event: React.FormEvent<HTMLInputElement>,
        stateName: string,
        typeField: string,
        typeCallback: string,
        required: boolean,
        vMax: number,
        vMin?: number
    ): void => {
        const tmp = { ...outputObject };
        FormGeneralHelper.validateFormsHook(
            tmp,
            setOutputObject,
            platformUserStatus,
            setPlatformUserStatus,
            event,
            stateName,
            typeField,
            require,
            vMax,
            vMin
        );
    };

    const valiedateForm = (): Array<string> => {
        const formErr = [];
        if (outputObject.username.length <= 4 || outputObject.username.length >= 64) {
            formErr.push('platform_user:err.username_length');
        }
        if (outputObject.personName.length <= 4 || outputObject.personName.length >= 64) {
            formErr.push('platform_user:err.name_length');
        }
        if (outputObject.email.length < 4 || outputObject.email.length > 256) {
            formErr.push('platform_user:err.email');
        }
        if (outputObject.newPassword && (outputObject.newPassword.length < 4 || outputObject.newPassword.length > 256)) {
            formErr.push('platform_user:err.password_length');
        }
        if (outputObject.newPassword && outputObject.repeatPassword && outputObject.newPassword !== outputObject.repeatPassword) {
            formErr.push('platform_user:err.password_difference');
        }
        if ((!outputObject.newPassword && outputObject.repeatPassword) || (outputObject.newPassword && !outputObject.repeatPassword)) {
            formErr.push('platform_user:err.password_difference');
        }

        return formErr;
    };

    const handleSelectFunc = (e: any, stateName: string, require: boolean): void => {
        if (stateName === 'permissionGroupId') {
            setOutputObject({ ...outputObject, [stateName]: e.target.value, accountExpiration: getDateFromPermissionGroup(e.target.value) });
        } else {
            setOutputObject({ ...outputObject, [stateName]: e.target.value });
        }
    };

    const getDateFromPermissionGroup = (groupId: number): string | null => {
        let accountExpirationTime = null;
        if (collections && collections['hydra:member']) {
            collections['hydra:member'].forEach((el: any) => {
                if (el.id === groupId) {
                    accountExpirationTime = el.accountExpiration;
                }
            });
        }

        if (accountExpirationTime) {
            let now = DateHelperTs.convertToMoment(DateHelperTs.getCurrentDateTime());
            if (now) {
                now = DateHelperTs.addDaysToDate(now, accountExpirationTime);

                return DateHelper.formatYYYYMMDD(now);
            }
        }

        return null;
    };

    const filterRoles = (collections: any): any => {
        if (collections && collections['hydra:member']) {
            const level = Auth.getCustomerLevel();
            if (level && level > 2) {
                const filtered: Array<any> = [];
                collections['hydra:member'].map((el: any) => {
                    if (!el.adminRole) {
                        filtered.push(el);
                    }
                });
                return { 'hydra:member': filtered };
            }
        }
        return collections;
    };

    useEffect(() => {
        if (props.outputObject) {
            const tmpOutputObject = { ...props.outputObject };
            setOutputObject(tmpOutputObject);
        }
    }, [props.outputObject]);

    useEffect(() => {
        const filter1 = props.userId ? [{ name: 'userId', value: props.userId }] : [];
        const filter2 = props.resellerId ? [{ name: 'platformResellerId', value: props.resellerId }] : [];
        const filter3 = [{ name: 'superUserRole', value: false }];

        let filters = [...filter1, ...filter2, ...filter3];

        const itemLoaders = new ItemLoaders(dispatch);
        itemLoaders.getListWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/platform_user_defined_roles', configDefault.PLATFORM_API_PREFIX)),
            platformUserDefinedRolesConstants.LIST,
            !UserRoleHelper.checkRole(roles.ROLE_SUPERUSER) ? filters : [],
            [{ name: 'mainname', value: 'asc' }],
            (data: any) => {
                setCollections(data);
            },
            {
                propagateDataToCallback: true,
                dispatchAfterCallback: false,
            }
        );
    }, [dispatch, props.resellerId, props.userId]);

    useEffect(() => {
        if (!file) {
            return;
        }

        const data = new FormData();
        data.append('file', file);
        data.append('type', 'system.user.certificate');
        data.append(
            'params',
            JSON.stringify({
                type: 'system.user.certificate',
            })
        );

        apiCall
            .uploadFile(FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/uploads')), data)
            .then((response: any): void => {
                const { data } = response;
                setFileName(file.name);
                setFile(null);
                const info = JSON.parse(data['hydra:member'][0]);
                setSerial(info.serial);
                setSerialExpiration(info.expiration);
                const tmpOutputObject = { ...outputObject };
                if (tmpOutputObject.systemAccount) {
                    tmpOutputObject.certificateSerialHash = info.serial;
                    tmpOutputObject.certificateValidTo = info.expiration;
                }
                setOutputObject(tmpOutputObject);
            })
            .catch((error: any): any => {
                setFile(null);
                setFileName(null);
                setSerial(null);
                setSerialExpiration(null);
                const tmpOutputObject = { ...outputObject };
                if (tmpOutputObject.systemAccount) {
                    tmpOutputObject.certificateSerialHash = undefined;
                    tmpOutputObject.certificateValidTo = undefined;
                }
                setOutputObject(tmpOutputObject);
                NotificationHelper.notifyError('platform_user:a.cannot_process_certificate', dispatch);
            });
    }, [file, dispatch, outputObject]);

    const selectFile = (event: any): void => {
        const file = event.target.files[0];
        setFile(file);
    };

    return (
        <React.Fragment>
            <Card>
                <CardHeader trans="platform_user:h.user_detail" />
                <CardBody>
                    {outputObject && (
                        <GridContainer spacing={1}>
                            <GridItem xs={6}>
                                <InputForm
                                    stateName={'username'}
                                    callback={updateCallback}
                                    status={platformUserStatus['username']}
                                    typeField={'text'}
                                    displayFieldName={'platform_user:h.username'}
                                    required={true}
                                    value={outputObject?.username}
                                    vMin={4}
                                    vMax={64}
                                    typeCallback={'string'}
                                    autoComplete="new-username"
                                />
                            </GridItem>
                            <GridItem xs={6}>
                                <InputForm
                                    stateName={'personName'}
                                    callback={updateCallback}
                                    status={platformUserStatus['personName']}
                                    typeField={'text'}
                                    displayFieldName={'platform_user:h.name'}
                                    required={true}
                                    value={outputObject?.personName}
                                    vMin={4}
                                    vMax={64}
                                    typeCallback={'string'}
                                    autoComplete="new-person-name"
                                />
                            </GridItem>

                            <GridItem xs={6}>
                                {outputObject.allowGenericLogin && (
                                    <InputForm
                                        stateName={'newPassword'}
                                        callback={updateCallback}
                                        status={platformUserStatus['newPassword']}
                                        typeField={'password'}
                                        displayFieldName={'platform_user:h.password'}
                                        required={props.resellerId ? true : false}
                                        value={outputObject?.newPassword}
                                        vMin={4}
                                        vMax={64}
                                        typeCallback={'string'}
                                        autoComplete="new-password"
                                    />
                                )}
                            </GridItem>
                            <GridItem xs={6}>
                                {outputObject.allowGenericLogin && (
                                    <InputForm
                                        stateName={'repeatPassword'}
                                        callback={updateCallback}
                                        status={platformUserStatus['repeatPassword']}
                                        typeField={'password'}
                                        displayFieldName={'platform_user:h.repeat_password'}
                                        required={props.resellerId ? true : false}
                                        value={outputObject?.repeatPassword}
                                        vMin={4}
                                        vMax={64}
                                        typeCallback={'string'}
                                        autoComplete="new-password"
                                    />
                                )}
                            </GridItem>
                            <GridItem xs={6}>
                                <InputForm
                                    stateName={'email'}
                                    callback={updateCallback}
                                    status={platformUserStatus['email']}
                                    typeField={'email'}
                                    displayFieldName={'platform_user:h.email'}
                                    required={true}
                                    value={outputObject?.email}
                                    vMin={4}
                                    vMax={256}
                                    typeCallback={'string'}
                                    autoComplete="new-email"
                                />
                            </GridItem>

                            <GridItem xs={6}>
                                {(props.userId && props.userId === id && UserRoleHelper.checkRole(roles.ROLE_SUPERUSER)) ||
                                (outputObject.platformUserApiRoles &&
                                    collections &&
                                    outputObject.platformUserApiRoles.includes(roles.ROLE_SUPERUSER) &&
                                    !UserRoleHelper.checkRole(roles.ROLE_SUPERUSER)) ? null : (
                                    <SimpleSelectRest
                                        callback={handleSelectFunc}
                                        restElements={filterRoles(collections)}
                                        stateName="permissionGroupId"
                                        idState="id"
                                        idSelected={outputObject.permissionGroupId}
                                        propKey="id"
                                        required={false}
                                        propValue="mainname"
                                        emptyLabel={'platform_user:h.permission_group'}
                                        label={'platform_user:h.permission_group'}
                                    />
                                )}
                            </GridItem>

                            {process.env.REACT_APP_HIDE_DOMAIN !== 'true' && (
                                <GridItem xs={3}>
                                    <CheckBoxSimple
                                        checked={!outputObject.allowGenericLogin}
                                        disabled={outputObject.systemAccount}
                                        label={'platform_user:h.domain_user'}
                                        callback={(param: boolean): void => {
                                            const tmpOutputObject = { ...outputObject };
                                            tmpOutputObject.allowGenericLogin = !param;
                                            if (!tmpOutputObject.allowGenericLogin) {
                                                tmpOutputObject.repeatPassword = 'GENERIC_LOGIN';
                                                tmpOutputObject.newPassword = 'GENERIC_LOGIN';
                                            } else {
                                                tmpOutputObject.newPassword = null;
                                                tmpOutputObject.repeatPassword = null;
                                            }
                                            setOutputObject(tmpOutputObject);
                                        }}
                                    />
                                </GridItem>
                            )}
                            {process.env.REACT_APP_HIDE_DOMAIN !== 'true' && (
                                <>
                                    <GridItem xs={3}>
                                        <CheckBoxSimple
                                            checked={outputObject.systemAccount}
                                            label={'platform_user:h.system_user'}
                                            callback={(param: boolean): void => {
                                                const tmpOutputObject = { ...outputObject };
                                                tmpOutputObject.systemAccount = param;
                                                if (param) {
                                                    if (!tmpOutputObject.allowGenericLogin) {
                                                        tmpOutputObject.newPassword = null;
                                                        tmpOutputObject.repeatPassword = null;
                                                    }
                                                    tmpOutputObject.allowGenericLogin = true;
                                                }
                                                setOutputObject(tmpOutputObject);
                                            }}
                                        />
                                    </GridItem>
                                    <GridItem xs={6}>
                                        <CustomDatePicker
                                            helpText={'platform_user:h.account_expiration'}
                                            fieldName={'accountExpiration'}
                                            callback={(moment: Moment | string): void => {
                                                setOutputObject({ ...outputObject, accountExpiration: DateHelper.formatYYYYMMDD(moment) });
                                            }}
                                            placeholder={'YYY-MM-DD'}
                                            dateFormat={'YYYY-MM-DD'}
                                            autoComplete={'off'}
                                            defaultValue={outputObject.accountExpiration}
                                        />
                                    </GridItem>
                                    {props.platformUser && props.platformUser.systemAccount && props.platformUser.certificateSerialHash && (
                                        <>
                                            <GridItem xs={12} />
                                            <GridItem xs={3}>
                                                <div className={`${classes.button} ${classes.lg} ${classes.primary}`} style={{ cursor: 'default' }}>
                                                    <I18n
                                                        trans={'platform_user:a.current_certificate'}
                                                        valueObject={{
                                                            serial: props.platformUser.certificateSerialHash,
                                                            expiration: props.platformUser.certificateValidTo,
                                                        }}
                                                    />
                                                    <br />
                                                    <I18n
                                                        trans={'platform_user:a.certificate_valid_to'}
                                                        valueObject={{ expiration: props.platformUser.certificateValidTo }}
                                                    />
                                                </div>
                                            </GridItem>
                                            <GridItem xs={12} />
                                        </>
                                    )}
                                    {outputObject.systemAccount && (
                                        <>
                                            <GridItem xs={3}>
                                                <label htmlFor="btn-upload">
                                                    <input
                                                        id="btn-upload"
                                                        name="btn-upload"
                                                        style={{ display: 'none' }}
                                                        type="file"
                                                        onChange={selectFile}
                                                    />
                                                    <Button className={`${classes.button} ${classes.lg} ${classes.primary}`} component="span">
                                                        {serial && (
                                                            <>
                                                                <I18n
                                                                    trans={'platform_user:a.selected_certificate'}
                                                                    valueObject={{ serial: serial, filename: fileName, expiration: serialExpiration }}
                                                                />
                                                                <br />
                                                                <I18n
                                                                    trans={'platform_user:a.certificate_valid_to'}
                                                                    valueObject={{ expiration: serialExpiration }}
                                                                />
                                                            </>
                                                        )}
                                                        {!serial && <I18n trans="platform_user:a.select_certificate" />}
                                                    </Button>
                                                </label>
                                            </GridItem>
                                        </>
                                    )}
                                </>
                            )}
                        </GridContainer>
                    )}
                </CardBody>
                <CardFooter>
                    <GridContainer>
                        <GridItem xs={10} />
                        <GridItem xs={2}>
                            <CustomTextButtom
                                callback={(): void => {
                                    const err = valiedateForm();
                                    savePlatformUser(outputObject, err);
                                }}
                                size={'lg'}
                                color={'primary'}
                                label={'general:common.save'}
                            />
                        </GridItem>
                    </GridContainer>
                </CardFooter>
            </Card>
        </React.Fragment>
    );
};
